/**
 * Typed injection key for the shared queue manager composable context
 * @module queueManagerKey
 */
import type { InjectionKey } from 'vue'
import type { QueueManagerContext } from './useQueueManager'

export const queueManagerKey: InjectionKey<QueueManagerContext> = Symbol('queueManager')
